import { graphql } from "react-relay";
import "@components/work-address/WorkAddress.gql";

export const fragments = {
  org: graphql`
    fragment TravelTimeGoal_org on Org {
      id
      ...WorkAddress_org
      workAddressForUser {
        __typename
        ... on Address {
          rawAddress
        }
        ... on GraphEntityError {
          message
          statusCode
        }
      }
      userGoals(first: 1000000) {
        edges {
          node {
            id
            goalId
            name
            isDeleted
            targetUrn {
              id
              type
              value
            }
            otherUrns {
              id
              type
              value
            }
            name
            valueUrn {
              id
              type
              value
            }
            options {
              syncToGoogle
            }
          }
        }
      }
    }
  `,
};
